module.exports = __webpack_public_path__ + "me_text.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/me_text.svg
// module id = 25
// module chunks = 0